export const ACTION_TYPE = 'actionType';
export const STATIC_TO = 'staticTo';
export const TO_PROPERTY = 'toProperty';
export const USER_ID = 'userId';
export const BODY = 'body';